export default {
  id: "customTrendingProductUp",
  name: "",
  description: "",
  report: {
    name: "Trending Upwards",
    chartType: "TABLE",
    template: "custom",
    config: {
      dataType: "single",
      dataSet: "SaleItem",
      dimensions: ["Product.name"],
      measures: [
        "SaleItem.current_month_units_sold",
        "SaleItem.previous_month_units_sold",
        "SaleItem.month_over_month_percent_change",
      ],
      sort: {
        direction: "desc",
        by: "SaleItem.month_over_month_percent_change",
      },
      timeDimension: "SaleItem.sale_time",
      timeDateRange: "last month",
      applyDateRangeFilter: false,
      filterDateRange: false,
      filters: [],
      compare: false,
      limit: "10",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
